module.exports = __webpack_public_path__ + "img/512df44b4896e63320b80111b2b0661b.63143a8b.jpg";